import { Typography } from 'design-system/components/Typography';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { TChipsData } from '../types';

const ActionChip = forwardRef<HTMLDivElement, Omit<TChipsData, 'variant'>>(
  function Foo(props, ref) {
    return (
      <div
        ref={ref}
        className={twMerge(
          'flex h-fit w-fit items-center gap-2 rounded-full bg-Other/InputFieldBackground-Chips px-2 py-[5px] text-Text/Lightbackground/Primary',
          props.disabled
            ? 'bg-Action/Disabled_background text-Text/Lightbackground/Disabled'
            : 'hover:bg-Action/Hover focus:border focus:border-Other/Outlinedborder-stroke focus:bg-transparent active:bg-Action/DC/Selected active:text-Primary/Main',
          props.className
        )}
      >
        {props.startIcon}
        <Typography variant={'metadata'}>{props.children}</Typography>
        {props.endIcon}
      </div>
    );
  }
);

export default ActionChip;
